import { render, staticRenderFns } from "./InboundBundlesModal.vue?vue&type=template&id=0b3e3fe4"
import script from "./InboundBundlesModal.vue?vue&type=script&lang=js"
export * from "./InboundBundlesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports